import CodeEditor from 'sharedComponents/CodeEditor';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

const CodeEditorInput = ({
  id,
  name,
  error,
  control,
  intlLabel,
  errorIntl,
  defaultValue,
  rules,
  className,
  fullWidth = true,
  sx,
  mode,
  editable = true,
}) => {
  const [focused, setFocused] = useState(false);
  return (
    <FormControl fullWidth={fullWidth} className={className} sx={sx} error={error}>
      {intlLabel && (
        <InputLabel htmlFor={id} focused={focused} shrink>
          <FormattedMessage {...intlLabel} />
        </InputLabel>
      )}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        error={error}
        render={({ field }) => (
          <CodeEditor
            editable={editable}
            marginTop={!!intlLabel}
            width="100%"
            height="100%"
            mode={mode || 'javascript'}
            id={id}
            content={field.value}
            onChange={field.onChange}
            inputRef={field.ref}
            onFocusChangeCallback={hasFocus => setFocused(hasFocus)}
          />
        )}
      />
      {error && (
        <FormHelperText>
          <FormattedMessage {...errorIntl} />
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CodeEditorInput;
